<template>
    <div class="box">
        <div>

            <div class="row mt-3">
                <div class="col-12 pb-1 border-bottom">
                    <h5 class="h5-sor">申请提现 </h5>
                </div>
            </div>

            <div class="row mb-3 px-1 py-1" id="buy">
                <form id="passwordForm" class="w-100 mt-3" action="/user/password" method="post">
                    <div class="form-group row">
                        <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">* 提现方式</label>
                        <div class="col-8 p-0">
                            <label for="paytype1">银行卡</label>
                            <input type="radio" name="pay_type" id="paytype1" value="1" v-model="pay_type">
                            <label for="paytype2" class="ml-2">支付宝</label>
                            <input type="radio" name="pay_type" id="paytype2" value="2" v-model="pay_type">
                            <label for="paytype3" class="ml-2">微信</label>
                            <input type="radio" name="pay_type" id="paytype3" value="3" v-model="pay_type">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">* 提现账户</label>
                        <div class="col-8 p-0">
                            <input type="text" class="form-control" name="account" placeholder="请输入提现账户" v-model="account">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">* 提现金额(元)</label>
                        <div class="col-8 p-0">
                            <input type="number" class="form-control" name="amount" min="0" placeholder="请输入提现金额"
                                v-model="amount">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">* 手机号</label>
                        <div class="col-8 p-0">
                            <input type="number" class="form-control" name="phone_number" placeholder="请输入手机号"
                                v-model="phone_number">
                        </div>
                    </div>
                    <button @click="edit" type="button" class="btn btn-success btn-block">立即提现</button>
                    <br>

                </form>
            </div>

            <div class="row mb-5">
                <h6 class="col-11 ml-2 mt-3">提现记录:</h6>
                <div class="col-12 pb-1">
                    <el-table ref="multipleTable" :data="tableData">
                        <el-table-column prop="account" label="提现账户" width="150">
                        </el-table-column>

                        <el-table-column prop="amount" label="提现金额">
                        </el-table-column>

                        <el-table-column prop="pay_type" label="提现方式">
                            <template slot-scope="scope">
                                <p>{{ payTypeOptions[scope.row.pay_type] }}</p>
                            </template>
                        </el-table-column>

                        <el-table-column prop="phone_number" label="手机号">
                        </el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <p>{{ statusOptions[scope.row.status] }}</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>


                <div class="sh-20"></div>

                <el-pagination background layout="prev, pager, next" :pager-count="11" @current-change="pageChange"
                    :current-page="page" :total="count">
                </el-pagination>
            </div>

        </div>
        <footerPage></footerPage>
    </div>
</template>
    
<script>
import footerPage from "@/components/userInfo/footer"
import { getUserId } from "../../axios/token";
export default {
    name: "withDrawal",
    components: { footerPage },
    data () {
        return {
            user_id: parseInt(getUserId()),
            pay_type: '1',
            amount: 0,
            account: '',
            phone_number: '',
            page: 1,
            tableData: [],
            count: 10,
            payTypeOptions: [null, '银行卡', '支付宝', '微信'],
            statusOptions: ['待处理', '转账成功', '转账失败']
        }
    },
    created () {
        this.getDetailData(1)
    },
    methods: {
        edit () {
            if (!this.account || !this.phone_number || !this.amount) return this.$message('带*号的为必填项,且提现金额需大于0')
            if (!/^1[3456789]\d{9}$/.test(this.phone_number)) return this.$message('请输入正确的手机号')
            this.axios.post('/user/cashOutSet', JSON.stringify({
                user_id: this.user_id,
                pay_type: Number(this.pay_type),
                amount: Number(this.amount),
                account: this.account,
                phone_number: this.phone_number
            }), {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.page = 1
                    this.getDetailData(1)
                    return this.$message({
                        type: "success",
                        message: "申请提现成功"
                    })
                } else {
                    this.$message(res.data.msg)
                }
            }).catch((err) => {
                this.$message(err.message)
            })
        },
        pageChange (p) {
            this.getDetailData(p)
        },
        getDetailData (page) {
            this.page = page
            this.axios.get('/user/cashOutList', {
                params: {
                    userId: this.user_id,
                    page: page
                }
            }).then(resp => {
                var data = resp.data.data
                this.tableData = data.datas;
                this.count = data.count
            }).catch(() => {
                this.$message.error('哦，请求出错');
            });
        }
    }
}
</script>
    
<style scoped>
@media (min-width: 768px) {
    .h5-sor {
        font-size: 2rem;
    }

    .account-info {
        font-size: 1rem;
    }

    .account-info>dt {
        padding-right: 0;
    }

    .container-md {
        max-width: 960px;
    }
}

::v-deep .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}
</style>